
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machinery/[id]",
      function () {
        return require("private-next-pages/machinery/[id].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machinery/[id]"])
      });
    }
  